/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Outlook_Ingest_Approval_ApprovedInputs */

const es_components_outlook_ingest_approval_approved = /** @type {(inputs: Components_Outlook_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de adjuntos aprobada`)
};

const en_components_outlook_ingest_approval_approved = /** @type {(inputs: Components_Outlook_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment ingestion approved`)
};

/**
* | output |
* | --- |
* | "Attachment ingestion approved" |
*
* @param {Components_Outlook_Ingest_Approval_ApprovedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_outlook_ingest_approval_approved = /** @type {((inputs?: Components_Outlook_Ingest_Approval_ApprovedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Outlook_Ingest_Approval_ApprovedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_outlook_ingest_approval_approved(inputs)
	return en_components_outlook_ingest_approval_approved(inputs)
});
export { components_outlook_ingest_approval_approved as "components.outlook_ingest_approval.approved" }